import { Fragment } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonMunicipalityCrumbs } from '../constants';
import { HttpResponse } from 'shell/models/http-response';
import { Municipality } from 'shell/models/municipality';
import { noop } from 'shell/utils/noop';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { transformResponseMunicipalityEditItalian } from 'system/geographic/utils/transformer-municipality-edit';
import FormMunicipality, { MunicipalityForm } from 'system/geographic/components/municipality/form';

const MunicipalityDetailItalianPage = (): React.ReactElement => {
  const params = useParams();

  const [municipalityData] = useHttpFetch<HttpResponse<Municipality>, MunicipalityForm>(
    `${__MUNICIPALITY_API_URL__}/geo/comune/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
      },
      transformer: transformResponseMunicipalityEditItalian,
    }
  );

  const municipality = municipalityData.data as MunicipalityForm;

  const navigate = useNavigate();

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonMunicipalityCrumbs, { name: 'Dettaglio Comune Italiano' }]} />
      {municipalityData.isLoading || municipalityData.hasErrors || !municipality ? undefined : (
        <FormMunicipality
          title="Dettaglio Comune Italiano"
          onOk={noop}
          initialValues={municipality}
          disabled
          onCancel={() => {
            navigate('/sistema/geografiche/comune');
          }}
        />
      )}
    </Fragment>
  );
};

MunicipalityDetailItalianPage.displayName = 'Municipality Detail italian page component';

export default MunicipalityDetailItalianPage;
